// extracted by mini-css-extract-plugin
export default {"wrapper":"Mbi_nnX4yxfTp3EHGpAJ","addButton":"uixsQNac_gewel_F5r2O"};